(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-profile/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/player-profile/assets/javascripts/router.js');

'use strict';

svs.player_profile.Router = svs.app.ServerSideHelper.ServerSideRouterDecorator.decorate({
  $documentBody: $(document.body),
  routes: svs.core.data.routes,
  initialize() {
    svs.player_profile.logger.debug('svs.player_profile.router.View initialize');
    this.setDefaultRegion(svs.player_profile.app.getRegion());
  },
  execute(callback, args) {
    if (callback) {
      callback.call(this, args);
    }
    this.$documentBody.prop('scrollTop', 0);
  },
  headerBackArrowCallback() {
    let url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/uppgifter';
    svs.player_profile.router.navigateIfRoute(url, true);
  },
  navigateIfRoute(route) {
    let internalRoute = route;
    if (route) {
      if (route.charAt() === '/') {
        internalRoute = route.substring(1);
      }
      if (this.routes[internalRoute]) {
        this.navigate(internalRoute, true);
      } else {
        svs.player_profile.logger.info("Got navigation request for nonexisting route: ".concat(route, ", doing normal navigation."));
        svs.utils.url.navigate(route);
      }
    }
  },
  start() {
    if (!(this.defaultRegion.currentView instanceof svs.player_profile.views.Start)) {
      this.showView(svs.player_profile.views.Start, {
        page: 'profile',
        urlList: svs.player_profile.data.internalUrlList
      });
    } else {
      svs.player_profile.radio.trigger('navigation', 'start');
    }
    svs.accountservices.subpage.utils.handleHeaderAndNavigation('Min profil');
  },
  kyc() {
    if (!(this.defaultRegion.currentView instanceof svs.player_profile.views.Start)) {
      this.showView(svs.player_profile.views.Start, {
        page: 'kyc',
        urlList: svs.player_profile.data.internalUrlList
      });
    } else {
      svs.player_profile.radio.trigger('navigation', 'kyc');
    }
    svs.accountservices.subpage.utils.handleHeaderAndNavigation('Min profil');
  },
  kycQuestions() {
    this.showView(svs.player_profile.views.Kyc, {
      returnUrl: svs.player_profile.data && svs.player_profile.data.returnUrl,
      isSubpage: true
    });
    svs.accountservices.subpage.utils.handleHeaderAndNavigation('Min profil', 'Kundkännedom - Mina svar', this.headerBackArrowCallback, 'penningtvatt');
  },
  kycMessages() {
    svs.components.kyc_messages.showKYCMessage(undefined, () => {
      window.location.href = svs.utils.url.makeInternal(svs.player_profile.data.returnUrl, '/');
    }, undefined, svs.utils.url.makeInternal(svs.player_profile.data.returnUrl, '/'));
    svs.accountservices.subpage.utils.handleHeaderAndNavigation('Min profil', 'Penningtvätt', this.headerBackArrowCallback);
  },
  showProfileView(clientAction) {
    const options = svs.player_profile.data.profileSetup[clientAction];
    if (svs.player_profile.data && svs.player_profile.data.returnUrl) {
      options.returnUrl = svs.player_profile.data.returnUrl;
    }
    options.urlList = svs.player_profile.data.internalUrlList;
    options.isSubpage = true;
    this.showView(svs.player_profile.views.Profile, options);
    svs.accountservices.subpage.utils.handleHeaderAndNavigation('Min profil', options.pageTitle, this.headerBackArrowCallback);
  },
  profile() {
    this.showProfileView('profile');
  },
  profileTranscript() {
    this.showProfileView('profileTranscript');
  },
  profileEmail() {
    this.showProfileView('profileEmail');
  },
  profileComEmail() {
    this.showProfileView('profileComEmail');
  },
  profileVerifyEmail() {
    this.showProfileView('profileVerifyEmail');
  },
  profileComVerifyEmail() {
    this.showProfileView('profileComVerifyEmail');
  },
  profileConfirmEmail() {
    this.showProfileView('profileConfirmEmail');
  },
  profileMobile() {
    this.showProfileView('profileMobile');
  },
  profileComMobile() {
    this.showProfileView('profileComMobile');
  },
  profileMissingEmail() {
    this.showProfileView('profileMissingEmail');
  },
  profileConfirmMobile() {
    this.showProfileView('profileConfirmMobile');
  },
  profileComConfirmMobile() {
    this.showProfileView('profileComConfirmMobile');
  },
  profileVerifyMobile() {
    this.showProfileView('profileVerifyMobile');
  },
  profileAlias() {
    this.showProfileView('profileAlias');
  },
  profileAliasPoker() {
    this.showProfileView('profileAliasPoker');
  },
  profileMissingContactinfo() {
    this.showProfileView('profileMissingContactinfo');
  },
  setFullScreen() {
    $('.js-main-content').removeClass('main-content-constrained bg-grey-100').addClass('bg-white');
  }
});

 })(window);